module.exports = __webpack_public_path__ + "img/novotel.e0a27ad6.png";